import type { EmotionCache } from '@emotion/cache';

import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';

import type { Direction } from './index';

// Emotion cache rebuilt per direction. The provider in theme-provider.tsx swaps the cache
// when language toggles, so all subsequent MUI styles are mirrored.
//
// Why no `prefixer` from stylis: Emotion v11 already runs its own prefixer in the default
// pipeline. Adding stylis's `prefixer` on top crashed inside MUI v7's TextField style
// insertion ("Cannot read properties of undefined (reading 'push')" deep in stylis's
// combine/lift). MUI's RTL docs include prefixer for v5/v6, but with @emotion/cache@11.14
// it's redundant and incompatible.

export function createEmotionCache(direction: Direction): EmotionCache {
  return createCache({
    key: direction === 'rtl' ? 'mui-rtl' : 'mui-ltr',
    stylisPlugins: direction === 'rtl' ? [rtlPlugin] : [],
  });
}
